// ─── Hardware (USB / HID keyboard-wedge) barcode scanner normalisation ───────
//
// Plug-in scanners are usually configured to wrap the barcode in a prefix
// and/or suffix character. Settings → Scanner lets the shop configure those,
// plus a minimum length so a stray short keystroke burst is not treated as a
// scan. This helper applies that configuration to a raw wedge capture.

export interface HardwareScannerPrefs {
  hardwareScannerEnabled: boolean;
  scannerPrefix: string;
  scannerSuffix: string;
  minBarcodeLength: number;
}

/**
 * Returns the cleaned barcode, or `null` when the capture should be ignored
 * (hardware scanning disabled, or shorter than the configured minimum).
 */
export function normalizeScannedBarcode(
  raw: string,
  prefs: HardwareScannerPrefs,
): string | null {
  if (!prefs.hardwareScannerEnabled) return null;

  let code = raw.trim();
  if (prefs.scannerPrefix && code.startsWith(prefs.scannerPrefix)) {
    code = code.slice(prefs.scannerPrefix.length);
  }
  if (prefs.scannerSuffix && code.endsWith(prefs.scannerSuffix)) {
    code = code.slice(0, code.length - prefs.scannerSuffix.length);
  }
  code = code.trim();

  const min = prefs.minBarcodeLength > 0 ? prefs.minBarcodeLength : 1;
  if (code.length < min) return null;
  return code;
}
